import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Divider, Input, Popconfirm, Popover, Space, Table, Tag, message } from 'antd'
import { DeleteOutlined, EyeOutlined, SearchOutlined, ProfileOutlined } from '@ant-design/icons'
import moment from 'moment'
import * as Constants from '../../../constants'
import './styles.css'
import { storage, firestore, cloudFunctions } from '../../../config/Fire'
import Search from 'antd/lib/input/Search'

const WorkOrdersTable = ({ data, employees, clients, onRemoveWorkOrder, onShowWorkOrder, loading, bids }) => {
    const [searchedColumn, setSearchedColumn] = useState('')
    const [searchText, setSearchText] = useState('')
    let searchInput = useRef(null)
    const linkFileRef = useRef(null)
    const linkFileRefOT = useRef(null)

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText(selectedKeys[0])
        setSearchedColumn(dataIndex)
    }

    const handleReset = clearFilters => {
        clearFilters()
        setSearchText('')
    }

    const getKeyArea = areas => {
        const keyAreas = []
        Object.keys(Constants.areaWorkOrderMap).forEach(key => {
            areas.forEach(area => {
                if (area === Constants.areaWorkOrderMap[key]) {
                    keyAreas.push(key)
                }
            })
        })
        if (keyAreas.length === 0) {
            return `--`
        } else {
            return <Popover content={<ul>
                {
                    keyAreas.map(keyArea => <li key={keyArea}>{keyArea}: {Constants.areaWorkOrderMap[keyArea]}</li>)
                }
            </ul>}>
                <span>{keyAreas[0]} <ProfileOutlined /></span>
            </Popover>
        }
    }

    const isValueInWorkOrder = (record, value) => {
        if (record.SAT) {
            const workOrderTextFormat = `O/T SAT/${record['year'].toString().substring(2, 4)}`
            return (record['year'].toString().toLowerCase().includes(value.toLowerCase()) || workOrderTextFormat.toString().toLowerCase().includes(value.toLowerCase()))
        } else {
            const workOrderTextFormat = `O/T Nº${record['workOrderNumber']}/${record['year'].toString().substring(2, 4)}`
            return (record['workOrderNumber'].toString().toLowerCase().includes(value.toLowerCase()) || record['year'].toString().toLowerCase().includes(value.toLowerCase()) || workOrderTextFormat.toString().toLowerCase().includes(value.toLowerCase()))
        }
    }

    const isAreasMatched = (areas, value) => {
        let isValue = false
        Object.keys(Constants.areaWorkOrderMap).forEach(initials => {
            areas.forEach(area => {
                if ((Constants.areaWorkOrderMap[initials] === area && initials.toString().toLowerCase().includes(value.toString().toLowerCase()))
                    || area.toString().toLowerCase().includes(value.toLowerCase())) {
                    isValue = true
                }
            })
        })
        return isValue
    }

    const getColumnSearchProps = (dataIndex, name) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node
                    }}
                    placeholder={`Buscar ${name}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Limpiar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#279FA3' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex] !== undefined
                ? dataIndex === 'workOrderNumber'
                    ? isValueInWorkOrder(record, value)
                    : dataIndex === 'areas'
                        ? isAreasMatched(record[dataIndex], value)
                        : dataIndex === 'hasTopography'
                            ? (record[dataIndex] === true ? 'Pendiente de viaje' : record[dataIndex] === false ? 'No contempla' : record[dataIndex])
                                .toString().toLowerCase().includes(value.toLowerCase())
                            : record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100)
            }
        },
        render: (text, record) =>
            'completionPercentage' === dataIndex ?
                text === 100 ?
                    <span className="workOrderCompletedPercentage">{`${text} %`}</span>
                    :
                    <span>{`${text} %`}</span>
                :
                'workOrderNumber' === dataIndex ?
                    record.SAT ?
                        <span>O/T SAT/{record['year'].toString().substring(2, 4)}</span>
                        :
                        <span>O/T Nº{record['workOrderNumber']}/{record['year'].toString().substring(2, 4)}</span>
                    :
                    'areas' === dataIndex ?
                        <span>{getKeyArea(text)}</span>
                        :
                        <span>{text}</span>
    })

    const findValueInEmployees = (value, record) => {
        let valueFinded = false
        record.professionalIds.forEach(id => {
            if (employees && employees[id] && employees[id].name.toString().toLowerCase().includes(value.toLowerCase())) {
                valueFinded = true
            }
        })
        return valueFinded
    }

    const findValueInClients = (value, record) => {
        let valueFinded = false
        record.clientIds.forEach(id => {
            if (clients && clients[id] && clients[id].name.toString().toLowerCase().includes(value.toLowerCase())) {
                valueFinded = true
            }
        })
        return valueFinded
    }

    const getColumnSearchPropsWithIds = (dataIndex, name) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node
                    }}
                    placeholder={`Buscar ${name}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Limpiar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#279FA3' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? dataIndex === 'professionalIds' ? findValueInEmployees(value, record)
                    : findValueInClients(value, record)
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100)
            }
        },
        render: (text, record) =>
            dataIndex === 'professionalIds' ? getEmployeesByIds(record.professionalIds)
                : getClientsByIds(record.clientIds)
    })

    const getEmployeesByIds = professionalIds => {
        if (employees && professionalIds.length > 0) {
            if (professionalIds.length === 1) {
                if (professionalIds[0]) {
                    return employees[professionalIds[0]]?.name !== undefined ? `${employees[professionalIds[0]]?.name}` : `--`
                } else {
                    return `- -`
                }
            } else {
                return <Popover content={<ul>
                    {
                        professionalIds.map(id => employees[id] && <li key={id}>{employees[id].name}</li>)
                    }
                </ul>}>
                    {employees[professionalIds[0]] ? <span>{employees[professionalIds[0]].name}
                        <Tag>+{professionalIds.length - 1}</Tag></span> : '...'}
                </Popover>
            }
        } else {
            return '--'
        }
    }

    const getClientsByIds = clientIds => {
        if (clients && clientIds.length > 0) {
            if (clientIds.length === 1) {
                if (clientIds[0] && clients[clientIds[0]]) {
                    return `${clients[clientIds[0]].name}`
                } else {
                    return `- -`
                }
            } else {
                return <Popover content={<ul>
                    {
                        clientIds.map(id => clients[id] && <li key={id}>{clients[id].name}</li>)
                    }
                </ul>}>
                    {clients[clientIds[0]] ?
                        <span>{clients[clientIds[0]].name} <Tag>+{clientIds.length - 1}</Tag></span> : '...'}
                </Popover>
            }
        } else {
            return '--'
        }
    }

    const isWorkOrderOnTime = workOrder => {
        if (workOrder.expectedCompletionDate !== '' && workOrder.effectiveEndDate !== '') {
            const expectedDateLong = moment(`${workOrder.expectedCompletionDate} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').toDate().getTime()
            const endDateLong = moment(`${workOrder.effectiveEndDate} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').toDate().getTime()
            if (expectedDateLong >= endDateLong) {
                return 'SI'
            } else {
                return 'NO'
            }
        } else {
            if (workOrder.expectedCompletionDate !== '') {
                const todayDateLong = moment(`${moment().utcOffset('-0300').format('DD/MM/YYYY')} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').toDate().getTime()
                const expectedDateLong = moment(`${workOrder.expectedCompletionDate} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').toDate().getTime()
                if (todayDateLong <= expectedDateLong) {
                    return '-'
                } else {
                    return 'NO'
                }
            } else {
                return '-'
            }
        }
    }

    const getTotalTrips = workOrder => {
        let totalTrips = 0
        if (workOrder.trips) {
            workOrder.trips.length > 0 ? totalTrips = workOrder.trips.length : totalTrips = 0
        }
        return totalTrips
    }

    const getState = workOrder => {
        if (workOrder.state === 'anulada') {
            return 'gray'
        } else {
            if (workOrder.delivered) {
                return 'green'
            } else {
                // Verificar si todos los items están completados
                const items = workOrder.selectedItems || workOrder.items || []
                if (items.length > 0) {
                    const allItemsCompleted = items.every(item => item.completed === true)
                    if (allItemsCompleted) {
                        return 'green'
                    }
                }
                return 'orange'
            }
        }
    }

    const downloadFile = (id) => {
        // Buscar el bid por workOrderId (registros viejos) o por bidId en works
        let bidFound = null
        Object.values(bids).forEach(bid => {
            // Compatibilidad con registros viejos
            if (bid.workOrderId === id) {
                bidFound = bid
            }
        })
        // Si no se encontró por workOrderId, buscar por bidId en works
        if (!bidFound && data) {
            const work = Object.values(data).find(w => w.id === id)
            if (work && work.bidId) {
                bidFound = bids[work.bidId]
            }
        }
        if (bidFound && bidFound.fileUrl) {
            storage.ref().child(bidFound.fileUrl).getDownloadURL().then(url => {
                if (linkFileRef && linkFileRef.current) {
                    linkFileRef.current.href = url
                    linkFileRef.current.click();
                    linkFileRef.current.remove();
                }
            })
        }
    }

    const downloadFileOT = (prop) => {
        if (prop.fileUrl) {
            storage.ref().child(prop.fileUrl).getDownloadURL().then(url => {
                if (linkFileRefOT && linkFileRefOT.current) {
                    linkFileRefOT.current.href = url
                    linkFileRefOT.current.click();
                    linkFileRefOT.current.remove();
                }
            })
        } else {
            message.error('No se encontró el archivo')
        }
    }

    const downloadValidationFile = (prop) => {
        if (prop.validationFileUrl) {
            storage.ref().child(prop.validationFileUrl).getDownloadURL().then(url => {
                if (linkFileRefOT && linkFileRefOT.current) {
                    linkFileRefOT.current.href = url
                    linkFileRefOT.current.click();
                    linkFileRefOT.current.remove();
                }
            }).catch(() => {
                message.error('No se encontró el archivo')
            })
        } else {
            message.error('No se encontró el archivo')
        }
    }

    const getQuotation = (id) => {
        let label = '';
        if (bids && data) {
            // Buscar por workOrderId (registros viejos)
            Object.values(bids).forEach(bid => {
                if (bid.workOrderId === id) {
                    label = bid.quotation
                }
            })
            // Si no se encontró, buscar por bidId en works
            if (!label) {
                const work = Object.values(data).find(w => w.id === id)
                if (work && work.bidId && bids[work.bidId]) {
                    label = bids[work.bidId].quotation
                }
            }
        }
        if (label === '') {
            return '--'
        } else {
            return label
        }
    }

    const getOTLabel = (prop) => {
        const company = prop?.company === 'SD' ? 'SYD' : prop?.company === 'Arcasa' ? 'ARC' : 'O/T'
        if (prop.SAT) {
            return `${company} Nº${prop['workOrderNumber']}/${prop['year'].toString().substring(2, 4)} (SAT)`
        } else {
            return `${company} Nº${prop['workOrderNumber']}/${prop['year'].toString().substring(2, 4)}`
        }
    }

    const getTotalBilling = (prop) => {
        if (prop.invoicedFreePercentaje && prop.invoicedPercentaje) {
            return `${prop.invoicedFreePercentaje - prop.invoicedPercentaje}%`
        } else return '0%'
    }

    const onCancelWorkOrder = id => {
        firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(id).update({ state: 'anulada' })
            .then(async () => {
                message.success('La orden de trabajo se anuló exitósamente')
                const workOrderImp = data.find(workOrder => workOrder.id === id)
                const workOrderLabel = getOTLabel(workOrderImp)
                workOrderImp.workOrderLabel = workOrderLabel
                const data2 = {
                    workOrderID: workOrderImp.id,
                    type: 'OT_DOWN',
                    detailsOT: workOrderImp
                }
                await cloudFunctions.sendEmails(data2)
                window.location.reload()
            })
            .catch(err => {
                console.log(err)
                message.error('Se produjo un error al anular la orden de trabajo. Por favor, vuelva a intentarlo')
            })
    }

    const getValidationName = (prop) => {
        if (prop.company === 'Arcasa') {
            return `VP-ARC-${prop.workOrderNumber.toString().padStart(3, '0')}`
        } else if (prop.company === 'SD') {
            return `VP-SYD-${prop.workOrderNumber.toString().padStart(3, '0')}`
        }
    }

    const columns = [
        {
            title: 'Estado',
            dataIndex: 'state',
            key: 'state',
            align: 'center',
            width: '3%',
            render: (text, record) =>
                <span>
                    {
                        getState(record) === 'red' ?
                            <div className='circleRed'></div>
                            : getState(record) === 'orange' ?
                                <div className='circleOrange'></div>
                                : getState(record) === 'green' ?
                                    <div className='circleGreen'></div>
                                    : getState(record) === 'gray' ?
                                        <div className='circleGray'></div>
                                        : <div className='circleOrange'></div>
                    }
                </span>
        },
        {
            title: 'Orden de trabajo',
            dataIndex: 'workOrderNumber',
            key: 'workOrderNumber',
            align: 'center',
            render: (text, record) =>
                <span>
                    <div className='fileName' onClick={() => { downloadFileOT(record) }}>{getOTLabel(record)}</div>
                    <a ref={linkFileRefOT} href="" target='_blank' download />
                </span>
        },
        {
            title: 'Cotización',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            render: (text, record) =>
                <span>
                    <div className='fileName' onClick={() => { downloadFile(text) }}>{getQuotation(text)}</div>
                    <a ref={linkFileRef} href="" target='_blank' download />
                </span>
        },
        {
            title: 'Validación',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            render: (text, record) => {
                if (record.validationFileUrl) {
                    return (<span>
                        <div className='fileName' onClick={() => { downloadValidationFile(record) }}>{getValidationName(record)}</div>
                        <a ref={linkFileRef} href="" target='_blank' download />
                    </span>)
                }
                return '-'
            }
        },
        {
            title: 'Areas',
            dataIndex: 'areas',
            key: 'areas',
            align: 'center',
            width: '3%',
            ...getColumnSearchProps('areas', 'area')
        },
        {
            title: 'Profesional',
            dataIndex: 'professionalIds',
            key: 'professionalIds',
            align: 'center',
            width: '6%',
            ...getColumnSearchPropsWithIds('professionalIds', 'profesional')
        },
        {
            title: 'Localidad',
            dataIndex: 'locality',
            key: 'locality',
            align: 'center',
            width: '10%',
            ...getColumnSearchProps('locality', 'localidad')
        },
        {
            title: 'Comitente',
            dataIndex: 'clientIds',
            key: 'clientIds',
            align: 'center',
            width: '15%',
            ...getColumnSearchPropsWithIds('clientIds', 'cliente')
        },
        {
            title: 'Tarea',
            dataIndex: 'task',
            key: 'task',
            align: 'center',
            width: '23%',
            ...getColumnSearchProps('task', 'Tarea')
        },
        {
            title: 'Fecha de entrega',
            dataIndex: 'expectedCompletionDate',
            key: 'expectedCompletionDate',
            align: 'center',
            width: '5%',
            render: (text, record) => <span>{text !== "" ? text : '--'}</span>
        },
        {
            title: 'Pendiente de facturar',
            dataIndex: 'billingPending',
            key: 'billingPending',
            align: 'center',
            width: '5%',
            render: (text, record) => <span>{getTotalBilling(record) ?? '0'}</span>
        },
        {
            title: 'Viajes',
            dataIndex: 'trips',
            key: 'trips',
            align: 'center',
            width: '5%',
            render: (text, record) => <span>{text ? getTotalTrips(record) : '0'}</span>
        },
        {
            title: 'Tercerizado',
            dataIndex: 'outsourced',
            key: 'outsourced',
            align: 'center',
            width: '2%',
            render: (text, record) => record.outsourced ? 'SI' : 'NO'
        },
        {
            title: 'Avance',
            dataIndex: 'completionPercentage',
            key: 'completionPercentage',
            align: 'center',
            width: '2%',
            ...getColumnSearchProps('completionPercentage', '% de avance')
        },
        {
            title: 'Finalización',
            dataIndex: 'effectiveEndDate',
            key: 'effectiveEndDate',
            align: 'center',
            ...getColumnSearchProps('effectiveEndDate', 'fecha de finalización')
        },
        {
            title: 'Entregado',
            dataIndex: 'delivered',
            key: 'delivered',
            align: 'center',
            render: (text, record) => record.delivered ? 'SI' : 'NO'
        },
        {
            title: 'A tiempo',
            dataIndex: 'onTime',
            key: 'onTime',
            align: 'center',
            width: '2%',
            render: (text, record) => isWorkOrderOnTime(record)
        },
        {
            title: '',
            key: 'cancel',
            align: 'center',
            render: (text, record) =>
                <Popconfirm disabled={loading} title="Se anulara la orden de trabajo, ¿Continuar?" onConfirm={() => onCancelWorkOrder(record.id)}>
                    <Button loading={loading}>{!loading && 'Dar de baja'}</Button>
                </Popconfirm>
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            align: 'center',
            render: (text, record) =>
                <span className='actionButtons'>
                    <Button loading={loading} onClick={() => onShowWorkOrder(record.id)}>{!loading &&
                        <EyeOutlined style={{ color: 'blue' }} />}</Button>
                    <Divider type="vertical" />
                    <Popconfirm disabled={loading} title="Se borrará la orden de trabajo, ¿Continuar?"
                        onConfirm={() => onRemoveWorkOrder(record.id)}>
                        <Button loading={loading}>{!loading && <DeleteOutlined style={{ color: 'red' }} />}</Button>
                    </Popconfirm>
                </span>
        }
    ]

    return (
        <Table className="workOrdersTableCont" dataSource={data} columns={columns}
            rowKey="id" size="small" bordered scroll={{ x: 1300 }} />
    )
}

WorkOrdersTable.propTypes = {
    data: PropTypes.array,
    employees: PropTypes.object,
    clients: PropTypes.object,
    loading: PropTypes.bool
}

export default WorkOrdersTable
